// extracted by mini-css-extract-plugin
export var devider = "builder-module--devider--1Q_oz";